/** Suma totalValueUsd de líneas PTB (control: pie = Σ líneas, no total PTC). */
export function sumPtbLineTotals(lineas) {
  const sum = (lineas || []).reduce((s, ln) => s + (Number(ln.totalValueUsd) || 0), 0);
  return sum > 0 ? Math.round(sum * 100) / 100 : null;
}

/** Total FOB PTB: prioriza suma de líneas comerciales; no reutiliza totales PTC. */
export function resolvePtbTotalUsd(lineas, mercTotalUsd = null) {
  const fromLines = sumPtbLineTotals(lineas);
  if (fromLines != null) return fromLines;
  const merc = Number(mercTotalUsd);
  if (Number.isFinite(merc) && merc > 0) return Math.round(merc * 100) / 100;
  return null;
}
